import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { coursePackagesData } from '../data/courseData';
import './NavBar.css';

function NavBar({ onContactClick }) {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navRef = useRef(null);

    const handleLinkClick = () => {
        setDropdownOpen(false);
        setMobileMenuOpen(false);
    };

    const handleContactClick = () => {
        onContactClick();
        setMobileMenuOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMobileMenuOpen(false);
            }
        };

        if (isMobileMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    return (
        <nav className="nav" ref={navRef}>
            <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                <div className="nav-left">
                    <Link to="/" className="nav-link nav-home-link" onClick={handleLinkClick}>Home</Link>
                    <div
                        className="nav-item-dropdown"
                        onMouseEnter={() => setDropdownOpen(true)}
                        onMouseLeave={() => setDropdownOpen(false)}
                    >
                        <span className="nav-link">
                            Resources
                            {/* Updated: Replaced text caret with a modern SVG icon */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={`dropdown-caret ${isDropdownOpen ? 'active' : ''}`}
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </span>
                        {isDropdownOpen && (
                            <div className="dropdown-menu">
                                {coursePackagesData.map(course => (
                                    <Link
                                        key={course.id}
                                        to={`/resources/${course.slug}`}
                                        className="dropdown-link"
                                        onClick={handleLinkClick}
                                    >
                                        {course.name}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                    <Link to="/course-showcase" className="nav-link" onClick={handleLinkClick}>Course Showcase</Link>
                    <Link to="/about-us" className="nav-link" onClick={handleLinkClick}>About Us</Link>
                </div>
                <div className="nav-right">
                    <button className="contact-button" onClick={handleContactClick}>Contact Us</button>
                </div>
            </div>

            <button
                className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle menu"
            >
                <span className="hamburger-bar"></span>
                <span className="hamburger-bar"></span>
                <span className="hamburger-bar"></span>
            </button>
        </nav>
    );
}

export default NavBar;